module.exports = __webpack_public_path__ + "static/media/Linoone_gaussian2.d92f13da.png";